import PropTypes from 'prop-types'

import { tpmsSensorLocationPropType } from './tpms-sensor-location-prop-type'
import { tpmsMeasurementPropType } from './tpms-measurement-prop-type'

/**
 * @typedef {Object} TpmsSensorMeasurements
 * @property {TpmsSensorLocation} sensorLocation
 * @property {Array<TpmsMeasurement>} measurements
 */
export const tpmsSensorMeasurementsPropType = PropTypes.shape({
    sensorLocation: tpmsSensorLocationPropType,
    measurements: PropTypes.arrayOf(tpmsMeasurementPropType)
})
